import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import qs from 'qs';
import { format, parse } from 'date-fns';

const datetimeFormat = 'yyyyMMddHHmm';

export function formatDate(date: Date): string {
  return format(date, datetimeFormat);
}

export function parseDate(date: string, referenceDate: Date | number): Date {
  return parse(date, datetimeFormat, referenceDate);
}

export function isAxiosError(error: unknown): error is AxiosError {
  // axios.isAxiosError を上手く扱えないので用意
  return (error as AxiosError).isAxiosError === true;
}

export function getAxiosErrorResponse(
  error: unknown,
): AxiosResponse<any> | undefined {
  if (isAxiosError(error)) {
    return error.response;
  }
  return undefined;
}

export function parseUrlQuery(search: string): qs.ParsedQs {
  return qs.parse(search, {
    ignoreQueryPrefix: true,
  });
}
export function stringifyUrlQuery(params: unknown): string {
  return qs.stringify(params, {
    indices: false,
    arrayFormat: 'repeat',
    serializeDate: (d) => formatDate(d),
  });
}

export function createRequestConfig(
  overwrite?: AxiosRequestConfig,
): AxiosRequestConfig {
  return {
    baseURL: window.location.origin,
    responseType: 'json',
    paramsSerializer: stringifyUrlQuery,
    ...overwrite,
  };
}
